import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';

const FieldWithCaption = ({ children, caption }) => (
	<>
		{children}
		{caption != null && <div className="order-form__caption">{caption}</div>}
	</>
);

FieldWithCaption.propTypes = {
	children: PropTypes.node.isRequired,
	caption: PropTypes.string,
};

export default FieldWithCaption;
